export default __webpack_public_path__ + "static/media/bicici.b7f12a31.png";